import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import Header from '../../components/Header';
import withGoBack from '../../common/withGoBack';
import withOnline from '../../common/withOnline';
import withUpdatedRoute from '../../common/withUpdatedRoute';
import withDerSearchFilter from '../../common/withDerSearchFilter';
import withDerFilter from '../../common/withDerFilter';
import Bugsnag from '../../helpers/bugsnag';
import { storeLastVisitedRoute } from '../../common/globals';
import withCaseDer from '../../common/withCaseDer';
import withDersProduct from '../../common/withDersProduct';
import withViewDersDetails from '../../common/withViewDersDetails';
import withIsShowButtons from '../../common/withIsShowButtons';
import withReadCaseData from '../../common/withReadCaseData';

class Ders extends Component {
  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onAddNonCaseDer = () => {
    try {
      const {
        setCaseDer, setDersProducts, online, notify, setIsShowButtons, setReadCaseData
      } = this.props;
      setIsShowButtons({
        isView: false,
        isEdit: false,
        isCreate: true,
        isCopy: false,
        isSaved: false,
        isSubmitted: false
      });
      if (online) {
        setCaseDer('');
        setDersProducts([]);
        setReadCaseData([]);
        this._onGoBack();
        browserHistory.push('/ders/add-der');
        // browserHistory.push('/ders/add-non-case-der');
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearchDers = () => {
    try {
      const {
        setCaseDer, setDersProducts, online, notify
      } = this.props;
      if (online) {
        setCaseDer('false');
        setDersProducts([]);
        this._onGoBack();
        browserHistory.push('/ders/search-ders');
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  UNSAFE_componentWillMount() {
    try {
      const {
        setUpdatedRoute,
        setDerFilter,
        setDerSearchFilter,
        setGoBack,
        setCaseDer,
        setViewDersDetails
      } = this.props;
      storeLastVisitedRoute('/ders');
      setUpdatedRoute('/ders');
      setDerFilter({});
      setDerSearchFilter({});
      setGoBack([]);
      setCaseDer('');
      setViewDersDetails(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    return (
      <section className="list-section">
        <Header
          sideMenu
        />
        <section className="billing-section">
          <div className="container g-4">
            <div className="row">
              <p className="der-title">Device Experience Reports</p>
            </div>
            <div className="row ders-main-section g-4">
              <div className="col-12">
                <Link className="btn btn-theme-alt btn-theme-outline-alt d-block btn-max-width" onClick={this._onAddNonCaseDer}>Add Non-Case DER</Link>
              </div>
              <div className="col-12">
                <Link className="btn btn-theme-alt btn-theme-outline-alt d-block btn-max-width" onClick={this._onSearchDers}>Search DERs</Link>
              </div>
              <div className="col-12">
                <p className="btn-max-width text-center">Note: DERs for cases are added from the Case card
                  menu accessed by selecting the 3 dots.
                </p>
              </div>
            </div>
          </div>
        </section>
      </section>
    );
  }
}

export default withDersProduct(
  withOnline(
    withGoBack(
      withNotify(
        withLoader(
          withUpdatedRoute(
            withDerSearchFilter(
              withIsShowButtons(
                withDerFilter(
                  withCaseDer(
                    withViewDersDetails(
                      withReadCaseData(
                        Ders
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);
